<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel" style="height: 500px;">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="validate" class="form-horizontal">
                    <div class="card-body">
                        <div class="form-group row">
                            <label class="text-left col-sm-3">Select Contract Type</label>
                            <div class="col-sm-6">
                                <div class="form-check form-check-inline">
                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                           @click="setContractType"
                                           class="form-check-input mb-1"
                                           data-vv-as="type"
                                           id="PURCHASE"
                                           name="type"
                                           type="radio"
                                           v-model="contract.type"
                                           v-validate="'required'"
                                           value="PURCHASE">
                                    <label class="form-check-label" for="PURCHASE">Purchase</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                           @click="setContractType"
                                           class="form-check-input mb-1"
                                           data-vv-as="type"
                                           id="SALE"
                                           name="type"
                                           type="radio"
                                           v-model="contract.type"
                                           v-validate="'required'"
                                           value="SALE">
                                    <label class="form-check-label" for="SALE">Sale</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="text-left control-label col-form-label col-sm-3">Partner Type</label>
                            <div class="col-sm-6 mt-2">
                                <div class="form-check form-check-inline">
                                    <input :class="{'is-invalid': submitted && errors.has('partner_type')}"
                                           class="form-check-input mb-1"
                                           data-vv-as="partner_type"
                                           id="Member"
                                           name="partner_type"
                                           type="radio"
                                           v-model="partner_type"
                                           v-validate="'required'"
                                           value="Member">
                                    <label class="form-check-label" for="Member">Member</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input :class="{'is-invalid': submitted && errors.has('partner_type')}"
                                           class="form-check-input mb-1"
                                           data-vv-as="partner_type"
                                           id="Supplier"
                                           name="partner_type"
                                           type="radio"
                                           v-model="partner_type"
                                           v-validate="'required'"
                                           value="Supplier">
                                    <label class="form-check-label" for="Supplier">Vendor</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="partner_type === 'Supplier'">
                            <label class="text-left col-sm-3 control-label col-form-label" for="partner">Select
                                Partner</label>
                            <div class="col-sm-6">
                                <multiselect
                                        :class="{'is-invalid': submitted && errors.has('partner')}"
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="false"
                                        :limit="3"
                                        :loading="isLoading"
                                        :max-height="600"
                                        :options="partners"
                                        :options-limit="300"
                                        :searchable="true"
                                        :show-no-results="false"
                                        @search-change="searchPartners"
                                        class="form-control"
                                        data-vv-as="partner"
                                        id="partner"
                                        label="partner"
                                        name="partner"
                                        open-direction="up"
                                        placeholder="Search Partners"
                                        track-by="id"
                                        v-model="contract.partner"
                                        v-validate="'required'">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc">
                                                {{ props.option.org_name }}
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc" v-if="props.option">
                                                <h5>{{ props.option.org_name }}</h5>
                                            </div>
                                            <div class="option__desc" v-else>
                                                <h5>Add New</h5>
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="afterList">
                                        <div class="col-xs-12">
                                            <router-link :to="{name: 'addgrower'}"
                                                         class="btn btn-block btn-lg btn-outline-success">
                                                <i class="fa fa-plus-circle"></i>&nbsp;Add Partner
                                            </router-link>
                                        </div>
                                    </template>
                                </multiselect>
                                <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{
                                    errors.first('partner') }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="partner_type === 'Member'">
                            <label class="col-sm-3 text-left control-label col-form-label"
                                   for="did">Member</label>
                            <div class="col-sm-6">
                                <multiselect
                                        :class="{'is-invalid': submitted && errors.has('member_id')}"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="true"
                                        :limit="3"
                                        :max-height="600"
                                        :options="members"
                                        :options-limit="300"
                                        :searchable="true"
                                        :show-no-results="false"
                                        @search-change="searchMembers"
                                        class="form-control"
                                        data-vv-as="buyer"
                                        id="did"
                                        label="short_name"
                                        name="member_id"
                                        open-direction="bottom"
                                        placeholder="Search Member"
                                        track-by="did"
                                        v-model="contract.member">
                                    <template slot="singleLabel" slot-scope="props">
                                        {{props.option.short_name}}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <h5>{{ props.option.short_name }}</h5>
                                            <div>{{ props.option.did | hex_format(10, '.....') }}</div>
                                        </div>
                                    </template>
                                </multiselect>
                                <div class="invalid-feedback" v-if="submitted && errors.has('member_id')">{{
                                    errors.first('member_id') }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" id="data_1">
                            <label class="text-left col-sm-3 control-label col-form-label" for="expires_at">Contract
                                Expiry Date</label>
                            <div class="input-group col-sm-6">
                                <div class="input-group-prepend date">
                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('expires_at')}"
                                       class="form-control"
                                       data-vv-as="expire_date"
                                       style="height: 42px"
                                       id="expires_at"
                                       name="expires_at"
                                       placeholder="mm/dd/yyyy"
                                       type="text"
                                       v-model="contract.expires_at"
                                       v-validate="isForward ? 'required': ''">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="text-left col-sm-3 control-label col-form-label"
                                   for="expires_at">Provenance</label>
                            <div class="input-group col-sm-6">
                                <input class="form-control"
                                       data-vv-as="provenance"
                                       id="provenance"
                                       name="provenance"
                                       placeholder="Provenance"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="text"
                                       v-model="contract.provenance">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ContractProps",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect},
        mounted() {
            this.$nextTick(() => {
                this.init();
            })
        },
        data() {
            return {
                submitted: false,
                isForward: false,
                isLoading: false,
                partners: [],
                members: [],
                contract: this.$parent.contract,
                partner_type: null
            }
        },
        methods: {
            init() {
                jQuery('#expires_at').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.contract.expires_at = event.target.value;
                });
            },
            async searchMembers(searchText) {
                let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                this.members = data.dids;
            },
            setContractType(event) {
                this.contract.member = null;
                this.contract.partner = null;
                this.contract.type = event.target.value;
            },
            async validate() {
                this.submitted = true;
                let valid = await this.$validator.validate();
                return valid;
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
        }
    }
</script>

<style scoped>

</style>
